
// React Imports
import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {ListItemIcon, ListItemText} from "@mui/material";
import CalculateIcon from "@mui/icons-material/Calculate";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Badge from "@mui/material/Badge";


export function StatsMenu() {

    const [anchorEl, setAnchorEl] = React.useState(null);

    const isMenuOpen = Boolean(anchorEl);

    const handleMenuOpen = (event) => {


        setAnchorEl(event.currentTarget);
        // console.log("this is the contract selected by the menu click: ", menuContractId);
        // console.log("menuContractName: ", menuContractName);
        // console.log("menuContractLevel: ", menuContractLevel);
        // console.log("menuProductId: ", menuProductId);
        // console.log("menuFailedExpressionCount: ", menuFailedExpressionCount);
        // console.log("menuFailedFilterCount: ", menuFailedFilterCount);
        // console.log("menuInputMissingCount: ", menuInputMissingCount);
        //

    };


    function handleCalcAll()  {
        console.log("Calc All Markets Triggered");
        handleMenuClose();
    };


    function handleCalcCurrentPeriod()  {
        console.log("Calc Current Period Triggered");
        handleMenuClose();
    };


    function handleCalcCustomPeriod()  {
        console.log("Calc Custom Period Triggered");
        handleMenuClose();
    };


    function handleCalcUsage()  {
        console.log("Calc Usage Triggered");
        handleMenuClose();
    };



    function handleMenuClose()  {
        setAnchorEl(null);
    };


    const crudId = 'primary-search-account-menu';

    const renderMenu = (

        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={crudId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem
                onClick={handleCalcAll}
            >
                <ListItemIcon>
                    <CalculateIcon color={"action"} fontSize="small" />
                </ListItemIcon>
                <ListItemText>Calc All Markets</ListItemText>
            </MenuItem>
            <MenuItem
                onClick={handleCalcCurrentPeriod}
            >
                <ListItemIcon>
                    <CalculateIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Calc Current Period</ListItemText>
            </MenuItem>
            <MenuItem
                onClick={handleCalcCustomPeriod}
            >
                <ListItemIcon>
                    <CalculateIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Calc Period Override</ListItemText>
            </MenuItem>
            <MenuItem
                onClick={handleCalcUsage}
            >
                <ListItemIcon>
                    <CalculateIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Calc Usage</ListItemText>
            </MenuItem>

        </Menu>
    );


    return (
        <div
        >
            <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={crudId}
                aria-haspopup="true"
                onClick= {handleMenuOpen}
                color="inherit"
            >
                <Badge variant="dot">
                    <MoreVertIcon
                        color="action"
                        fontSize="small"/>
                </Badge>
            </IconButton>

            {renderMenu}
        </div>
    );
}